
import React, { useEffect, useState } from 'react';
import {
    Box,
    Button,
    Typography,
    Modal,
    TextField
} from '@mui/material';
import SearchableDropdown from '../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx';
import { ConstantActions } from '../../Services/_actions/constant.actions.js';
import { useSnackBar } from '../FlowBuilder/Common/SnackBar/index.tsx';
import { useRecoilState, useRecoilValue } from 'recoil';
import { useNavigate } from 'react-router';
import { CampaignList, Form } from '../../interfaces/Flowbuilder.interface.ts';
import { userInformationAtom } from '../../Services/_states/auth.js';
import { CampaignListActions, LeadFormActions } from '../../Services/_actions/index.js';
interface CampaignFormSelectionModalProps {
    open: boolean;
    onClose: (data: { campaign: any; webForm: any; } | null) => void;
    isEdit: boolean;
    selectedCampaign?: any;
    selectedForm?: any;
}

const CampaignFormSelectionModal: React.FC<CampaignFormSelectionModalProps> = ({ open, onClose, isEdit, selectedCampaign, selectedForm }) => {
    const { showSnackBar } = useSnackBar();
    const navigate = useNavigate();
    const campaignActions = CampaignListActions();
    const leadFormActions = LeadFormActions();
    const loggedInUser = useRecoilValue(userInformationAtom)
    const [isloading, setIsLoading] = useState(false);
    const [campaignList, setCampaignList] = useState<CampaignList>({ pages: 0, list: [] });
    const [formData, setFormData] = useState<{ campaign: any; webForm: any; }>({ campaign: null, webForm: null });
    const [validationErrors, setValidationErrors] = useState({
        campaign: '',
        webForm: '',
        // phoneNumber: "",
    });
    const [filterForCamapign, setFilterForCamapign] = useState<{
        next_page: number;
        search: string;
        to: Number;
        include_assigned_by: Number;
        fetch_all: Number;
        organisationId: string;
    }>({
        to: loggedInUser?.id,
        include_assigned_by: 0,
        fetch_all: 0,
        next_page: 1,
        search: '',
        organisationId: '',
    });
    const [formList, setFormList] = useState<Form[]>([]);

    const validatePhoneNumber = (phone: string) => {
        const phoneRegex = /^([1-9]{1}[0-9]{1,12})$/;
        return phoneRegex.test(phone);
    };

    const fetchFormList = async (campaignId: string | null) => {
        setFormList([]);
        if (!campaignId) return;
        let res = await leadFormActions.getFormsByCampaignId(campaignId);
        if (res?.status === 200) {
            let data: any = Object?.values(res?.data);
            setFormList(data || []);
        }
    };
    const getCampaigns = async (filter: any) => {
        setFilterForCamapign({ ...filter });
        let res = await campaignActions.getCampaignAssignment(filter);
        setCampaignList(res);
    };
    const loadMoreOptions = async () => {
        if (filterForCamapign?.next_page <= campaignList?.pages) {
            if (filterForCamapign?.next_page > 1) {
                setIsLoading(true);
            }
            let listData = Array.isArray(campaignList?.list) ? [...campaignList?.list] : [];
            let data = { ...filterForCamapign, search: '', next_page: filterForCamapign?.next_page + 1 };
            setFilterForCamapign(data);

            let res = await campaignActions.getCampaignAssignment(data);
            if (Array.isArray(res?.list)) {
                listData = [...listData, ...res?.list];
            } else {
                showSnackBar('Received non-array response for campaign list.', 'error');
            }
            setCampaignList({ ...res, list: listData });
            setIsLoading(false);
        }
    };
    const handeSearchCampaign = (query: string) => {
        getCampaigns({ ...filterForCamapign, search: query || '', next_page: 1 });
    };


    const onSelectCampaign = async (value: any) => {
        setFormData({
            ...formData,
            webForm: null,
            campaign: value || null,
        });
        setFormList([]);
        // if (!value) {
        //     setFormList([]);
        //     return;
        // }
        fetchFormList(value?.proposal_id);
    };


    useEffect(() => {
        getCampaigns(filterForCamapign)
    }, []);

    useEffect(() => {
        if (isEdit && selectedCampaign) {
            setFormData({
                campaign: selectedCampaign,
                webForm: selectedForm || null,
            });

            fetchFormList(selectedCampaign?.proposal_id);
        }
    }, [isEdit, selectedCampaign, selectedForm]);


    const handleSubmit = () => {
        const errors: any = {};
        if (!formData.campaign) {
            errors.campaign = 'Organisation is required';
        }
        if (!formData.webForm) {
            errors.webForm = 'Web form is required';
        }
        // if (!validatePhoneNumber(formData.phoneNumber) || formData?.phoneNumber?.length < 10) {
        //     errors.phoneNumber = "Enter valid phone number with country code";
        // }
        setValidationErrors(errors);
        if (Object.keys(errors).length === 0) {
            onClose(formData);
        }
    };
    return (
        <Modal open={open} onClose={() => { onClose(null); }}>
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    borderRadius: '8px',
                    p: 3,
                    width: 400,
                    maxHeight: '90vh',
                    overflowY: 'auto',
                }}
            >
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                    Select
                </Typography>

                <SearchableDropdown
                    label={
                        <Typography component="span">
                            Select Campaign <span style={{ color: 'red' }}>*</span>
                        </Typography>
                    }
                    options={campaignList?.list || []}
                    labelKey='name'
                    valueKey='proposal_id'
                    value={formData?.campaign || null}
                    onSearch={handeSearchCampaign}
                    onChange={(value) => {
                        onSelectCampaign(value);
                    }}
                    loading={isloading}
                    sx={{ marginBottom: 1 }}
                    fetchMoreOptions={campaignList?.has_next ? loadMoreOptions : undefined}
                    getOptionDisabled={(option) => option.value === ''}
                    error={!!validationErrors?.campaign}
                    errorMessage={validationErrors?.campaign}

                />

                {formData?.campaign && (
                    <SearchableDropdown
                        label={
                            <Typography component="span">
                                Select Form <span style={{ color: 'red' }}>*</span>
                            </Typography>
                        }
                        options={formList || []}
                        labelKey='leads_form_name'
                        valueKey='leads_form_id'
                        value={formData?.webForm || null}
                        onChange={(value) => setFormData({ ...formData, webForm: value })}
                        sx={{ marginBottom: 1 }}
                        error={!!validationErrors?.webForm}
                        errorMessage={validationErrors?.webForm}
                    />
                )}

                {/* <TextField
                    label={
                        <Typography component="span">
                            Phone Number <span style={{ color: 'red' }}>*</span>
                        </Typography>
                    }
                    fullWidth
                    value={formData?.phoneNumber || ''}
                    onChange={(e) => {
                        setFormData({ ...formData, phoneNumber: e.target.value });
                        setValidationErrors({ ...validationErrors, phoneNumber: '' }); // Clear error
                    }}
                    sx={{ marginBottom: 2 }}
                    margin="dense"
                    variant="outlined"
                    size="small"
                    inputProps={{
                        maxLength: 13,
                    }}
                    error={!!validationErrors?.phoneNumber}
                    helperText={validationErrors?.phoneNumber}
                /> */}

                <Box mt={3} display="flex" justifyContent="flex-end" gap={2}>
                    <Button variant="outlined" onClick={() => { isEdit ? onClose(null) : navigate(-1); }} size="small">
                        Back
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleSubmit}
                        color="primary"
                        size="small"
                    >
                        Submit
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default CampaignFormSelectionModal;